/**
 * This is not a supported prebid partner, so we have to manually set up the requests in order to work along together prebid
 */

import { loadScript } from '../../utils/utils'
import logBase from '../../utils/logger'
import { APS_PUB_ID } from '../../constants'

const log = logBase.extend('PREBID').extend('Amazon')

export function initApsLogic() {
  log('Amazon ads is loading...')
  // @ts-expect-error 'import.meta' is handled by babel
  const apsScript = new URL('amazon-aps-script.min.js', import.meta.url).toString()

  return loadScript(apsScript).then(() => {
    window.apstag.init({
      pubID: APS_PUB_ID,
      adServer: 'googletag',
      simplerGPT: true,
    })
  })
}
